import Image from 'next/image';
import styled from 'styled-components';
import { color, media, spacing, typography } from '~/theme';
import colors from '~/theme/variables/colors';
import { rem } from '~/theme/variables/typography';
import { Heading2 } from '~/theme/headings';

export const RootContainer = styled.div`
    border-bottom: 3px solid ${colors.palette.black};

    .leadText {
        font-family: ${typography.fontSecondary};
        font-weight: ${typography.fontWeightBold};
    }
    padding-top: ${spacing.spacing4};
    padding-bottom: ${rem(56)};

    @media ${media.small} {
        padding-top: ${spacing.spacing6};
    }
`;

export const CardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: ${spacing.spacing5};

    @media ${media.small} {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
        gap: ${rem(30)};
        margin-top: ${spacing.spacing7};
    }
`;

export const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ServiceDescriptionContainer = styled.div`
    padding-top: ${spacing.spacing4};
`;

export const ServicesAvailableImage = styled(Image)`
    width: 100%;
    height: auto;
`;

export const NewBadge = styled.span`
    margin-left: ${spacing.spacing2};
    padding: ${spacing.spacing1} ${spacing.spacing2};
    background-color: ${color.palette.systemLightGreen};
    border-radius: ${spacing.spacing5};
    color: ${color.palette.black};
    &:hover {
        color: ${color.palette.black};
    }
`;
export const ServiceHeading = styled(Heading2)`
    max-width: 50rem;
}`;
